// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.color.ocean-50 {
  color: #e6f2ff;
}

.color.ocean-100 {
  color: #e6f2ff;
}

.color.ocean-200 {
  color: #b3daff;
}

.color.ocean-300 {
  color: #7abfff;
}

.color.ocean-400 {
  color: #2392fb;
}

.color.ocean-500 {
  color: #0074e0;
}

.color.ocean-600 {
  color: #043571;
}

.color.space-50 {
  color: #f0f0f0;
}

.color.space-100 {
  color: #e3e3e3;
}

.color.space-200 {
  color: #bfbfbf;
}

.color.space-300 {
  color: gray;
}

.color.space-400 {
  color: #616161;
}

.color.space-500 {
  color: #283439;
}

.color.gray-50 {
  color: #eff3f6;
}

.color.gray-100 {
  color: #e6ecef;
}

.color.gray-200 {
  color: #cfd8de;
}

.color.gray-300 {
  color: #a8b9c2;
}

.color.gray-400 {
  color: #7e98a5;
}

.color.gray-500 {
  color: #738f9c;
}

.color.green-50 {
  color: #e3fdf6;
}

.color.green-100 {
  color: #c5f6ea;
}

.color.green-200 {
  color: #69ddc2;
}

.color.green-300 {
  color: #45bfa3;
}

.color.green-400 {
  color: #1cab8a;
}

.color.green-500 {
  color: #128268;
}

.color.red-50 {
  color: #fff0f3;
}

.color.red-100 {
  color: #f9d2db;
}

.color.red-200 {
  color: #f8b4c4;
}

.color.red-300 {
  color: #e85e81;
}

.color.red-400 {
  color: #e23661;
}

.color.red-500 {
  color: #b82348;
}

.color.yellow-50 {
  color: #fffae6;
}

.color.yellow-100 {
  color: #fff0b3;
}

.color.yellow-200 {
  color: #ffe380;
}

.color.yellow-300 {
  color: #ffcf57;
}

.color.yellow-400 {
  color: #ffc60a;
}

.color.yellow-500 {
  color: #ffb700;
}

.color.orange-50 {
  color: #fff2eb;
}

.color.orange-100 {
  color: #ffe4d6;
}

.color.orange-200 {
  color: #ffc69e;
}

.color.orange-300 {
  color: #ffa047;
}

.color.orange-400 {
  color: #ff7b42;
}

.color.orange-500 {
  color: #ee4920;
}

.color.turquoise-50 {
  color: transparent;
}

.color.turquoise-100 {
  color: #e6fcff;
}

.color.turquoise-200 {
  color: #b3f5ff;
}

.color.turquoise-300 {
  color: #78e2f2;
}

.color.turquoise-400 {
  color: #00c7e6;
}

.color.turquoise-500 {
  color: transparent;
}

.color.turquoise-600 {
  color: transparent;
}

.color.violet-50 {
  color: #eae6ff;
}

.color.violet-100 {
  color: #d9d1ff;
}

.color.violet-200 {
  color: #bfb3ff;
}

.color.violet-300 {
  color: #9d90ea;
}

.color.violet-400 {
  color: #8678d9;
}

.color.violet-500 {
  color: #6f5ccc;
}

.color.snow-50 {
  color: white;
}

.color.snow-100 {
  color: #f7f7f7;
}

.color.snow-200 {
  color: #f0efef;
}

.color.snow-300 {
  color: #e6e6e6;
}

.color.snow-400 {
  color: #e1e0e0;
}

.color.snow-500 {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.background-color.ocean {
  background-color: #2392fb;
  color: white;
}

.background-color.ocean-light {
  background-color: #b3daff;
  color: white;
}

.background-color.green {
  background-color: #1cab8a;
  color: white;
}

.background-color.green-light {
  background-color: #69ddc2;
  color: white;
}

.background-color.red {
  background-color: #e23661;
  color: white;
}

.background-color.red-light {
  background-color: #f8b4c4;
  color: white;
}

.background-color.orange {
  background-color: #ff7b42;
  color: white;
}

.background-color.orange-light {
  background-color: #ffc69e;
  color: white;
}

.background-color.space {
  background-color: #616161;
  color: white;
}

.background-color.space-light {
  background-color: #bfbfbf;
  color: #616161;
}

.background-color.gray-light {
  background-color: #f0efef;
  color: #616161;
}

.background-color.violet {
  background-color: #8678d9;
  color: white;
}

.background-color.violet-light {
  background-color: #bfb3ff;
  color: #616161;
}

.background-color.yellow {
  background-color: #ffc60a;
  color: white;
}

.background-color.yellow-light {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
html {
  font-size: 14px;
}

/* Make html, body and root full height and with no overflow scroll bar */
html,
body,
#root {
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

/*
    Change scrollbar appearance in webkit
*/
body {
  scrollbar-color: #cfd8de white;
  scrollbar-width: thin;
  /* TODO: Radix-UI uses a portal for its tooltip which we need to set a z-index for.
   * We've styled it here since it's portaled into the "Body".
   * This is a quick fix for now, but needs to be removed and somehow moved to the component styles itself.
  */
}
body ::-webkit-scrollbar {
  height: 7px;
  width: 5px;
}
body ::-webkit-scrollbar-thumb {
  background: #cfd8de;
  border-radius: 5px;
}
body ::-webkit-scrollbar-track {
  background: transparent;
}
body ::-webkit-scrollbar-thumb:hover {
  background: #cfd8de;
}
body [data-radix-popper-content-wrapper] {
  z-index: 9999 !important;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/ui-kit/styles/web-app.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_misc.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA;EACI,eAAA;AA0UJ;;AAvUA,yEAAA;AACA;;;EAGI,YAAA;EACA,gBAAA;EACA,gBAAA;AA0UJ;;AAvUA;;CAAA;AAGA;EE8BI,8BAAA;EACA,qBAAA;EF5BA;;;GAAA;AA6UJ;AE9SI;EACI,WAAA;EACA,UAAA;AFgTR;AE7SI;EACI,mBAAA;EACA,kBAAA;AF+SR;AE5SI;EACI,uBAAA;AF8SR;AE3SI;EACI,mBAAA;AF6SR;AAvVI;EACI,wBAAA;AAyVR","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'theme';\n\n// Set html font size\nhtml {\n    font-size: theme.$typography-html-font-size;\n}\n\n/* Make html, body and root full height and with no overflow scroll bar */\nhtml,\nbody,\n#root {\n    height: 100%;\n    max-height: 100%;\n    overflow: hidden;\n}\n\n/*\n    Change scrollbar appearance in webkit\n*/\nbody {\n    @include theme.scrollbar();\n\n    /* TODO: Radix-UI uses a portal for its tooltip which we need to set a z-index for.\n     * We've styled it here since it's portaled into the \"Body\".\n     * This is a quick fix for now, but needs to be removed and somehow moved to the component styles itself.\n    */\n    [data-radix-popper-content-wrapper] {\n        z-index: theme.get-z-index(data-radix-popper-content-wrapper) !important;\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:math';\n@use 'sass:meta';\n@use './colors';\n\n@function if-important($important) {\n    @return #{if($important, '!important', '')};\n}\n\n@function strip-unit($value) {\n    @if meta.type-of($value) == 'number' and not math.is-unitless($value) {\n        @return math.div($value, ($value * 0 + 1));\n    }\n\n    @return $value;\n}\n\n@function is-map($variable) {\n    @return meta.type-of($variable) == 'map';\n}\n\n@function is-string($variable) {\n    @return meta.type-of($variable) == 'string';\n}\n\n// Reset the button to behave like div\n@mixin reset-button() {\n    appearance: none;\n    background-color: transparent;\n    border: 0;\n    border-radius: 0;\n    color: inherit;\n    cursor: pointer;\n    margin: 0;\n    outline: 0;\n    padding: 0;\n    position: relative;\n    -webkit-tap-highlight-color: transparent;\n    text-align: left;\n    text-decoration: none;\n    user-select: none;\n    vertical-align: middle;\n\n    &::-moz-focus-inner {\n        border-style: none;\n    }\n}\n\n@mixin scrollbar() {\n    // The new standard syntax (Currently only supported in Firefox)\n    scrollbar-color: colors.color(gray-200) colors.color(snow-50);\n    scrollbar-width: thin;\n\n    // For Chrome, Edge, Safari, and Opera\n    ::-webkit-scrollbar {\n        height: 7px;\n        width: 5px;\n    }\n\n    ::-webkit-scrollbar-thumb {\n        background: colors.color(gray-200);\n        border-radius: 5px;\n    }\n\n    ::-webkit-scrollbar-track {\n        background: transparent;\n    }\n\n    ::-webkit-scrollbar-thumb:hover {\n        background: colors.color(gray-200);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
